<div class="overlay">
  <div class="card">
    <div class="icon-wrapper">
      <div class="icon-circle">✔</div>
    </div>

    <h2>Assessment Submitted Successfully</h2>

    <div class="description-section">
      <p class="thank-you-msg">
        Thank you for completing your assessment for
        <span class="highlight">{{ assessmentTitle }}</span> at
        <strong>BeExpert.ai</strong>.
      </p>


      <div class="next-steps">
        <h3 class="steps-title">What happens next?</h3>
        <ul class="steps-list">
          <li>
            <div class="step-icon"><i class="bi bi-cpu-fill"></i></div>
            <div class="step-text">
              <strong>AI Analysis</strong>
              <p>
                Your assessment responses are being analyzed by our AI engine.
              </p>
            </div>
          </li>
          <li>
            <div class="step-icon">
              <i class="bi bi-file-earmark-bar-graph-fill"></i>
            </div>
            <div class="step-text">
              <strong>Report Generation</strong>
              <p>
                A comprehensive performance report is being generated for the
                hiring team.
              </p>
            </div>
          </li>
          <li>
            <div class="step-icon">
              <i class="bi bi-envelope-check-fill"></i>
            </div>
            <div class="step-text">
              <strong>Final Review</strong>
              <p>
                The team will review your results and contact you via your
                registered email.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="action-section" *ngIf="data.isFromStudentDashboard">
  <button class="primary-btn" (click)="goToHome()"> Go to My Applications</button>
</div>
  </div>
</div>